module.exports = __webpack_public_path__ + "6053ca3e96de9f8894fb61243d3b5cc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/areas/areas-affordable-housing.jpg
// module id = 118
// module chunks = 0